import { Component, createRef } from 'react';
import { mergeStyles, SearchBox } from '@fluentui/react';

export enum SearchCtrlStyle {
	Standard,
	Grey,
	Underlined,
}

interface ISearchCtrlProps {
	onSearchTextChanged: (searchText: string) => void;
	placeholder: string;
	style: SearchCtrlStyle;
	initialValue?: string;
}

interface ISearchCtrlState {
	searchText: string;
}

class SearchCtrl extends Component<ISearchCtrlProps, ISearchCtrlState> {
	private searchBoxElement = createRef<HTMLDivElement>();
	
	constructor(props: ISearchCtrlProps) {
		super(props);
		this.state = {
			searchText: props.initialValue || '',
		};
	}
	private _debounceTimeout: NodeJS.Timeout | undefined = undefined;

	private onSearchTextChange = async (_: any, query: string | undefined) => {
		query = query || '';

		this.setState({ searchText: query });

		if (this._debounceTimeout) {
			clearTimeout(this._debounceTimeout);
		}

		if (query) {
			this._debounceTimeout = setTimeout(() => {
				this.props.onSearchTextChanged(this.state.searchText);
			}, 300);
		} else {
			//The search text has been cleared - apply it immediately
			this.props.onSearchTextChanged('');
		}
	};

	render() {
		const searchBoxClass = mergeStyles({
			border: '1px solid rgb(196 194 194)',
			backgroundColor: 'rgb(242 242 242)',
		});

		const searchBoxClassTransparent = mergeStyles({
			backgroundColor: 'transparent !important',
		});

		let classNameToUse = undefined;
		if (this.props.style === SearchCtrlStyle.Grey) {
			classNameToUse = searchBoxClass;
		} else if (this.props.style === SearchCtrlStyle.Underlined) {
			classNameToUse = searchBoxClassTransparent;
		}

		return (
			<>
				<div ref={this.searchBoxElement}>
					<SearchBox
						underlined={this.props.style === SearchCtrlStyle.Underlined}
						placeholder={this.props.placeholder}
						className={classNameToUse}
						value={this.state.searchText}
						onChange={this.onSearchTextChange}
					/>
				</div>
			</>
		);
	}
}

export default SearchCtrl;
